/**
 * User-facing copy for editor-agent tools.
 *
 * Tool names are an internal protocol between the model and the editor. They
 * are useful for durable history and debugging, but must never leak into the
 * chat UI as `addSticker` / `setLayerTransition` strings.
 */
const TOOL_ACTION_LABELS: Record<string, string> = {
  addClip: 'Добавлен клип',
  addClipSegment: 'Добавлен найденный фрагмент',
  removeClip: 'Удалён клип',
  duplicateClip: 'Создана копия клипа',
  trimClip: 'Клип подрезан',
  splitClip: 'Клип разделён',
  reorderClip: 'Изменён порядок клипов',
  updateClipProperties: 'Обновлены настройки видео',
  setTrackState: 'Обновлены настройки дорожки',
  setClipTransition: 'Добавлен переход между клипами',
  removeClipTransition: 'Удалён переход между клипами',
  addText: 'Добавлен текст',
  addCaption: 'Добавлены субтитры',
  addSticker: 'Добавлен стикер',
  applyTemplate: 'Применён шаблон',
  applyEffect: 'Добавлен эффект',
  addCatalogEffect: 'Добавлен эффект',
  addMusic: 'Добавлена музыка',
  updateAudioTrack: 'Обновлены настройки музыки',
  removeAudioTrack: 'Удалена музыка',
  setAspectRatio: 'Изменён формат кадра',
  setCrossfade: 'Настроен плавный переход звука',
  updateLayer: 'Обновлён слой',
  setLayerTransition: 'Настроена анимация слоя',
  addLayerKeyframe: 'Добавлен ключевой кадр',
  removeLayer: 'Удалён слой',
  proposeGeneration: 'Подготовлен план генерации',
  searchLibraryContent: 'Медиатека проверена по содержимому',
};

const TOOL_PROGRESS_LABELS: Record<string, string> = {
  addClip: 'Добавляю клип…',
  addClipSegment: 'Добавляю найденный фрагмент…',
  removeClip: 'Удаляю клип…',
  duplicateClip: 'Создаю копию клипа…',
  trimClip: 'Подрезаю клип…',
  splitClip: 'Разделяю клип…',
  reorderClip: 'Меняю порядок клипов…',
  updateClipProperties: 'Обновляю видео…',
  setTrackState: 'Обновляю дорожку…',
  setClipTransition: 'Добавляю переход…',
  removeClipTransition: 'Удаляю переход…',
  addText: 'Добавляю текст…',
  addCaption: 'Добавляю субтитры…',
  addSticker: 'Добавляю стикер…',
  applyTemplate: 'Применяю шаблон…',
  applyEffect: 'Добавляю эффект…',
  addCatalogEffect: 'Добавляю эффект…',
  addMusic: 'Добавляю музыку…',
  updateAudioTrack: 'Настраиваю музыку…',
  removeAudioTrack: 'Удаляю музыку…',
  setAspectRatio: 'Меняю формат кадра…',
  setCrossfade: 'Настраиваю переход звука…',
  updateLayer: 'Обновляю слой…',
  setLayerTransition: 'Настраиваю анимацию слоя…',
  addLayerKeyframe: 'Добавляю ключевой кадр…',
  removeLayer: 'Удаляю слой…',
  proposeGeneration: 'Готовлю план генерации…',
  searchLibraryContent: 'Анализирую медиатеку…',
};

export function editorToolActionLabel(toolName: string): string {
  return TOOL_ACTION_LABELS[toolName] ?? 'Изменение применено';
}

export function editorToolProgressLabel(toolName: string): string {
  return TOOL_PROGRESS_LABELS[toolName] ?? 'Применяю изменение…';
}

export function editorToolHistorySummary(toolNames: string[]): string[] {
  return toolNames.map(editorToolActionLabel);
}
